import React from 'react';

export default function MedalsNumber(props) {

  return (
    <div className="MedalsNumber">
        {props.medalCount}
    </div>
  );
}